'use strict';

var MarketAnalysisToggleDirective = function MarketAnalysisToggleDirective($rootScope) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-analysis-toggle.html'),
    scope: {},
    controller: 'MarketAnalysisToggleController',
    link: function link(scope) {
      scope.$on('market-product-group:filterUpdated', scope.onFilterApplied);
      scope.$on('market-product-group:rowSelected', scope.onFilterApplied);
      scope.toggleMarketAnalysisMode = function (mode) {
        $rootScope.$broadcast('market-analysis-toggle:toggleMode', mode);
      };
      scope.$on('market-analysis-toggle:invoke', function (event, mode) {
        scope.toggleMode(mode);
      });
      scope.$on('search-criteria:searchChangeEvent', function () {
        scope.toggleMode(scope.MODE_MARKET);
      });
      scope.$on('market-product-group:goToServiceTab', function () {
        scope.toggleMode(scope.MODE_SERVICE);
      });
    }
  };
};
MarketAnalysisToggleDirective.$inject = ['$rootScope'];
module.exports = MarketAnalysisToggleDirective;